import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

// Define ModuleType enum locally until the package is rebuilt
export enum ModuleType {
  QUEUE_SYSTEM = 'queue_system', // 叫號系統
  APPOINTMENT_SYSTEM = 'appointment_system', // 預約系統
  THIRD_PARTY_QUEUE = 'third_party_queue', // 第三方叫號
}

// Define ClinicModule interface locally
export interface ClinicModule {
  clinic_module_id: number
  clinic_id: number
  module_type: string
  is_active: boolean
  created_at: Date
  updated_at: Date
}

// Using locally defined interfaces and enums

// Hook to fetch clinic modules
export function useModules(clinicId: number | null) {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<ApiResponse<ClinicModule[]>>(
    token && clinicId ? `/api/clinics/${clinicId}/modules` : null,
    undefined,
    token ?? '',
  )

  // Map module types to human-readable names
  const moduleTypeNames: Record<string, string> = {
    [ModuleType.QUEUE_SYSTEM]: '叫號系統',
    [ModuleType.APPOINTMENT_SYSTEM]: '預約系統',
    [ModuleType.THIRD_PARTY_QUEUE]: '第三方叫號',
  }

  // Get module name by type
  const getModuleName = (type: string): string => {
    return moduleTypeNames[type] || type
  }

  return {
    modules: data?.data || [],
    isLoading,
    isError: error,
    mutate,
    getModuleName,
  }
}
